import { Box, Divider } from "@chakra-ui/react";

import Question from "../components/Question";

const QuestionList = (props) => {
  return (
    <Box marginTop="5rem">
      {props.questions.map((question, index) => (
        <Box key={index} marginTop="2rem">
          <Divider />
          <Box marginTop="5">
            <Question
              question={question}
              tag={question?.tag}
              generatorId={props.generatorId}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default QuestionList;
